import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './style.scss?inline';

export default class SotbitDropdownFooter extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    render() {
        return html`<slot></slot>`;
    }
}
